import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css"; // Optional: for global styles

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Temporarily removing StrictMode to prevent double mounting in development
// which can cause timer issues
root.render(<App />);
